import {
  Card,
  Flex,
  Select,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const TableView = ({
  headData = [],
  body,
  maxW,
  footer,
  initialValue,
  rows,
  page,
  onPrevious,
  onNext,
  pagination,
  onChange,
  total_value,
}) => {
  return (
    <Card borderRadius={5}>
      <TableContainer
        flex={1}
        maxWidth={maxW || "full"}
        borderRadius={5}
        w="full"
        overflowX="auto"
      >
        <Table variant="simple">
          <Thead bg="#88888822">
            <Tr>
              {headData.map((v, i) => (
                <Th color="#000" key={i} textAlign="center" whiteSpace="nowrap">
                  {v}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>{body}</Tbody>
        </Table>
      </TableContainer>

      {pagination && (
        <Flex
          w="full"
          h="auto"
          justify={{ base: "center", md: "flex-end" }}
          alignItems="center"
          flexWrap="wrap"
          px={{ base: 4, md: 10 }}
          py={4}
          gap={4}
        >
          <Text fontSize="sm">Rows per page:</Text>
          <Select
            size="sm"
            maxW="70px"
            value={rows}
            onChange={onChange}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>

          <Flex gap={1} align="center" fontSize="sm">
            <Text>{initialValue}</Text>
            <Text>-</Text>
            <Text>{rows * page >= total_value ? total_value : rows * page}</Text>
            <Text>of {total_value}</Text>
          </Flex>

          <FiChevronLeft
            cursor="pointer"
            color={page === 1 ? "gray" : "#007bc9"}
            size={25}
            onClick={onPrevious}
          />

          <FiChevronRight
            cursor="pointer"
            color={rows * page >= total_value ? "gray" : "#007bc9"}
            size={25}
            onClick={onNext}
          />
        </Flex>
      )}
    </Card>
  );
};

export default TableView;
